import type { IRoute } from '@/router/helpers'
import { ContentLayout } from '@/layouts'

const route: IRoute = {
  path: 'payment',
  Component: ContentLayout,
  children: [
    {
      path: ':id/:payType',
      Component: lazy(() => import('@/views/payment/index')),
      meta: { title: '支付详情' },
    },
  ],
}

export default route
